/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Birthday from './Birthday/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import Greeting from './Greeting/index'
import LastName from './LastName/index'
import MiddleName from './MiddleName/index'
import PatientReferral from './PatientReferral/index'
import React from 'react'
import School from './School/index'
import Ssn from './Ssn/index'
import Title from './Title/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Details.Horizontal"
  data-view-path={viewPath}
 style={{'--fd-1-Z1gssM9': isMedia.mobile ? "column" : "row"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 style={{'--w-2-Z1gssM9': isMedia.mobile ? "100%" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Details.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-3-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
</div>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
<Greeting
  viewPath={`${viewPath}/Greeting`}
/>
</div>
<div
  data-testid="Details.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-4-Z1gssM9': isMedia.mobile ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-5-Z1gssM9': isMedia.mobile ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : "0px",'--w-2-Z1gssM9': isMedia.mobile ? "100%" : "auto"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Details.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-3-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<MiddleName
  viewPath={`${viewPath}/MiddleName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
</div>
<Birthday
  viewPath={`${viewPath}/Birthday`}
/>
<PatientReferral
  viewPath={`${viewPath}/PatientReferral`}
/>
<School
  viewPath={`${viewPath}/School`}
/>
</div>
</div>
{children}
</React.Fragment>)
}